<template>
    <div id="loading">
      <img src="../assets/image/icon_loading.png" alt="加载中" class="loading-img" />
      <span>生成中</span>
    </div>
  </template>
  
  <script>
  export default {
    // 如需控制加载状态，可添加数据属性
    data() {
      return {
        isLoading: true // 示例：控制加载显示状态
      };
    }
  }
  </script>
  
  <style>
  #loading {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: var(--tech-primary);
  }
  
  #loading img.loading-img {
    width: 28px;
    height: 28px;
    margin-right: 7px;
    animation: rotate 1s linear infinite;
  }
  
  /* 定义旋转动画 */
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  </style>